/*
 * @Author: duke
 * @Date: 2024-04-19 16:59:08
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
// 全局配置文件 

const version = "1.0.0"
const TestCipher = "ANYCUBIC"
const appid = "f9b3528877c94d5c9c5af32245db46ef"
const appSecret = "0cf75926606049a3937f56b0373b99fb"
const languageMap = {
    'en': 'US',
    'zh': 'CN',
    'de': 'DE',
    'ru': 'RU',
}

const objectName = "mqttObject"
const identity = 1720765067;

const lanCount = 5;

// function generateRandomId() {
//   // 生成一个介于0到1之间的随机数
//   const randomNumber = Math.random();
 
//   // 将随机数转换为一个32位的整数
//   const randomInteger = Math.floor(randomNumber * 2 ** 32);
 
//   // 返回这个整数作为ID
//   return randomInteger;
// }


export default {
    version,
    TestCipher,
    appid,
    appSecret,
    languageMap,
    objectName,
    identity,
    lanCount
};